import React, { useMemo, useState, useCallback } from "react";
import { observer } from "mobx-react-lite";

import {
  ExportSewerObjects,
  ExportSewerObjectsFromAssignedProject,
} from "../../../services/authorization/Permissions";
import { permissionsService } from "../../../services/authorization/UserPermissionsService";
import DownloadButton from "../download-button/DownloadButton";
import { DownloadSewerObjectsModal } from "./DownloadSewerObjectsModal";
import { exportSewerObjectsService } from "../../../services/sewer-object/ExportSewerObjectsService";

interface DownloadSewerObjectsButtonsProps {
  projectId?: number;
  jobId?: number;
  selectedSewerObjects: number[];
  allSewerObjectsCount: number;
  fileName: string;
}

export const DownloadSewerObjectsButtons = observer(
  (props: DownloadSewerObjectsButtonsProps) => {
    const {
      projectId,
      jobId,
      selectedSewerObjects,
      allSewerObjectsCount,
      fileName,
    } = { ...props };

    const [modalTitleKey, setModalTitleKey] = useState<string>("");
    const [sewerObjectsCount, setSewerObjectsCount] = useState<number>(0);
    const [sewerObjectIds, setSewerObjectIds] = useState<number[]>([]);

    const isDownloadAllSewerObjectsDisabled = useMemo(() =>
      !permissionsService.userHasOneOfThePermissions(
        [ExportSewerObjects, ExportSewerObjectsFromAssignedProject]
      ) || allSewerObjectsCount <= 0,
      [allSewerObjectsCount]
    );

    const isDownloadSewerObjectsDisabled = useMemo(() =>
      !permissionsService.userHasOneOfThePermissions(
        [ExportSewerObjects, ExportSewerObjectsFromAssignedProject]
      ) || selectedSewerObjects.length <= 0,
      [selectedSewerObjects.length]
    );

    const onClickDownloadAll = useCallback(() => {
      setModalTitleKey("sewer-objects.DownloadAllSewerObjectsModal.title");
      setSewerObjectsCount(allSewerObjectsCount);
      setSewerObjectIds([]);
      exportSewerObjectsService.showModal();
    }, [allSewerObjectsCount]);

    const onClickDownloadSelected = useCallback(() => {
      setModalTitleKey("sewer-objects.DownloadSelectedSewerObjectsModal.title");
      setSewerObjectsCount(selectedSewerObjects.length);
      setSewerObjectIds(selectedSewerObjects.map(id => Number(id)));
      exportSewerObjectsService.showModal();
    }, [selectedSewerObjects]);

    return (
      <>
        <DownloadButton
          disabled={isDownloadAllSewerObjectsDisabled}
          labelKey="sewer-objects.DownloadAllButton.label"
          onClick={onClickDownloadAll}
        />
        <DownloadButton
          disabled={isDownloadSewerObjectsDisabled}
          labelKey="sewer-objects.DownloadSelectedButton.label"
          onClick={onClickDownloadSelected}
        />
        <DownloadSewerObjectsModal
          projectId={projectId}
          jobId={jobId}
          sewerObjectIds={sewerObjectIds}
          isVisible={exportSewerObjectsService.modalIsVisible}
          modalTitleKey={modalTitleKey}
          sewerObjectsCount={sewerObjectsCount}
          fileName={fileName}
        />
      </>
    );
  }
);
